(() => {
  if (window.garanVariantHandlerInstalled) return;
  window.garanVariantHandlerInstalled = true;
  const pending = new WeakMap();
  document.addEventListener('on:variant:change', async (event) => {
    const detail = event.detail || {};
    const productId = String(detail.product?.id || '');
    if (!productId) return;
    const panels = [...document.querySelectorAll('[data-garan-product]')].filter(panel =>
      panel.dataset.garanProduct === productId &&
      !(panel.hasAttribute?.('data-garan-express') && detail.form && panel.closest('form') !== detail.form));
    await Promise.all(panels.map(async (panel) => {
      pending.get(panel)?.abort();
      const controller = new AbortController();
      pending.set(panel, controller);
      const label = panel.querySelector('[data-garan-label]');
      const loading = panel.querySelector('[data-garan-loading]');
      const error = panel.querySelector('[data-garan-error]');
      const retry = panel.querySelector('[data-garan-retry]');
      const checkout = panel.hasAttribute?.('data-garan-express')
        ? panel.closest('form')?.querySelector('[data-garan-express-checkout]') : null;
      if (checkout) checkout.hidden = true;
      label.hidden = true;
      error.hidden = true;
      loading.hidden = true;
      if (!detail.variant?.id) return;
      const url = new URL(panel.dataset.garanUrl, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('variant', String(detail.variant.id));
      retry.href = url.href;
      url.searchParams.set('section_id', panel.dataset.garanSection);
      loading.hidden = false;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Section unavailable');
        const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = [...documentCopy.querySelectorAll('[data-garan-product]')].find(candidate => candidate.dataset.garanProduct === productId && candidate.dataset.garanSection === panel.dataset.garanSection && candidate.dataset.garanVariant === String(detail.variant.id));
        if (!replacement) throw new Error('Selected variant unavailable');
        if (controller.signal.aborted || !panel.isConnected) return;
        label.replaceChildren(...replacement.querySelector('[data-garan-label]').childNodes);
        panel.dataset.garanVariant = String(detail.variant.id);
        label.hidden = false;
        if (checkout) checkout.hidden = false;
      } catch (e) {
        if (!controller.signal.aborted && panel.isConnected) error.hidden = false;
      } finally {
        if (!controller.signal.aborted && panel.isConnected) loading.hidden = true;
      }
    }));
  });
})();
